import React from "react";
import { AddRoadOutlined, HolidayVillageOutlined, PictureInPictureOutlined } from "@mui/icons-material";

import { MuPowerInputLayerId, MuPowerInputLayerIds } from "fond/types";
import { SvgIcon } from "fond/widgets";

export interface MuPowerInputLayerConfig {
  key: MuPowerInputLayerId;
  title: string;
  displayName: string;
  navigationKey: string;
  icon: React.ReactElement;
  geometryType: "Point" | "LineString" | "Polygon";
  group: "Base data";
  isRequired?: boolean;
}

export const muPowerInputLayers: MuPowerInputLayerConfig[] = [
  {
    key: MuPowerInputLayerIds.boundary,
    title: "Boundary",
    displayName: "Boundary",
    navigationKey: "mu-boundary",
    icon: <SvgIcon icon="polygon" />,
    geometryType: "Polygon",
    group: "Base data",
    isRequired: false,
  },
  {
    key: MuPowerInputLayerIds.addresses,
    title: "Addresses",
    displayName: "Addresses",
    navigationKey: "mu-address",
    icon: <HolidayVillageOutlined />,
    geometryType: "Point",
    group: "Base data",
    isRequired: true,
  },
  {
    key: MuPowerInputLayerIds.parcels,
    title: "Parcels",
    displayName: "Parcels",
    navigationKey: "mu-parcel",
    icon: <PictureInPictureOutlined />,
    geometryType: "Polygon",
    group: "Base data",
    isRequired: true,
  },
  {
    key: MuPowerInputLayerIds.streets,
    title: "Streets",
    displayName: "Streets",
    navigationKey: "mu-street",
    icon: <AddRoadOutlined />,
    geometryType: "LineString",
    group: "Base data",
    isRequired: true,
  },
  {
    key: MuPowerInputLayerIds.poles,
    title: "Poles",
    displayName: "Poles",
    navigationKey: "mu-pole",
    icon: <SvgIcon icon="points" />,
    geometryType: "Point",
    group: "Base data",
    isRequired: false,
  },
];
